module.exports = __webpack_public_path__ + "preview-icon.a4e4c7f0f08717919eb27b7babc35fb0.svg";